// ref: https://github.com/mapbox/geojson.io/blob/main/src/ui/draw/circle.js
import MapboxDraw from '@mapbox/mapbox-gl-draw';

import { circleFromTwoVertexLineString } from '..';

const DrawLineString = MapboxDraw.modes.draw_line_string;

export const DrawCircle = {
  ...DrawLineString,

  clickAnywhere: function (state, e) {
    if (state.currentVertexPosition === 1) {
      const lineGeoJson = state.line.toGeoJSON();

      const circle = this.newFeature(
        circleFromTwoVertexLineString(lineGeoJson)
      );

      state.circle = circle;

      this.addFeature(circle);

      this.deleteFeature([state.line.id], { silent: true });

      return this.changeMode('simple_select', {
        featureIds: [state.circle.id]
      });
    }

    state.line.updateCoordinate(
      state.currentVertexPosition,
      e.lngLat.lng,
      e.lngLat.lat
    );
    if (state.direction === 'forward') {
      state.currentVertexPosition += 1;
      state.line.updateCoordinate(
        state.currentVertexPosition,
        e.lngLat.lng,
        e.lngLat.lat
      );
    } else {
      state.line.addCoordinate(0, e.lngLat.lng, e.lngLat.lat);
    }

    return null;
  },

  onStop: function (state) {
    this.activateUIButton();

    if (!state.circle || !this.getFeature(state.circle.id)) {
      this.deleteFeature([state.line.id], { silent: true });
      return;
    }

    // Remove the last added coordinate
    if (state.line.coordinates.length > 0) {
      state.line.removeCoordinate(`${state.currentVertexPosition - 1}`);
    }

    return this.map.fire('draw.create', {
      features: [state.circle.toGeoJSON()]
    });
  },

  toDisplayFeatures: function (state, geojson, display) {
    const isActiveLine = geojson.properties.id === state.line.id;
    geojson.properties.active = String(isActiveLine);

    if (!isActiveLine) return display(geojson);

    if (geojson.geometry.coordinates.length < 2) return null;

    const circleFeature = circleFromTwoVertexLineString(geojson);
    circleFeature.properties = { active: 'true' };

    this.map.fire('draw.render', {
      features: [circleFeature]
    });

    return display(circleFeature);
  }
};
